import { withFormik } from 'formik';
import * as yup from 'yup';
import { validation } from '../../forms/util/validation';
var authentication = yup.object().shape({
  cateringDate: validation.cateringDate,
  foodDate: validation.foodDate
});
export var cartFormikEnhancer = withFormik({
  mapPropsToValues: function mapPropsToValues(props) {
    return {};
  },
  validationSchema: authentication,
  displayName: 'CartFormik' // helps with React DevTools

});